module.exports = __webpack_public_path__ + "media/stylesheets/images/media/attracting_image3-bbc0b5d84a3ccbbf6905191830e89ae0.jpg";